import React, { Component } from 'react';
import styles from './signUpDivider.module.scss';

import { Divider } from 'antd';

export class SignUpDivider extends Component {
  render(): JSX.Element {
    return (
      <Divider className={styles.divider}>Or</Divider>
    );
  }
}
